module.exports = __webpack_public_path__ + "img/big_11B15_orange.6c87e9fe.png";